import React, { Component } from 'react';

import './scroll-top.scss';

const goToTop = () => window.scrollTo(0, 0);

class ScrollTop extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isScroll: false
        };
    }

    componentDidMount() {
        document.addEventListener('scroll', () => {
            const isScroll = window.scrollY > 400;
            if (isScroll !== this.state.isScroll) {
                this.setState({ isScroll })
            }
        });
    }

    render() {
      return (
          <div className={`${this.state.isScroll ? 'scroll-top show' : 'scroll-top'} no-print`} onClick={goToTop}>
              <span>Scroll to Top</span>
          </div>
      )
    }
  }

  export default ScrollTop;
